import Game501 from './501'

class Game extends Game501 {
  FINAL_SCORE = 301
  EXTREME_SERIES = 10

  constructor(store, default_game, urls = window.URLS) {
    super(store, default_game, urls, '301')
  }
}

export default Game